export const allMenus = 'allMenus';
export const canvas = 'canvas';
export const estate = 'estate';
export const internal = 'internal';
export const replication = 'replication';
export const amazons3 = 'amazons3';
export const globalSearch = 'globalSearch';
export const credentials = 'credentials';
export const identityAccess = 'identityAccess';
export const addConnector = 'addConnector';
export const timeline = 'timeline';
export const workingenvironment = 'workingenvironment';
export const connectorsettings = 'connectorsettings';
export const notification = 'notification';
export const claimOrgAdmin = 'claimOrgAdmin';
export const license ='license';
export const vendor = 'vendor';
export const local = 'local';
export const connectors = 'connectors';
export const onPrem = 'onPrem';
export const leftNav = 'leftNav';
export const support = 'support';
export const mfe = 'mfe';
export const bxpAlerts = 'bxpAlerts';
export const mfa ='mfa';
export const currentConnector = 'currentConnector';
export const galleryComponents = 'galleryComponents';
export const whatsNew = 'whatsNew';
export const accountmanagement = 'accountmanagement';
export const autoUpgrade = 'autoUpgrade';
export const dark = 'dark';
export const appComponents = 'appComponents';
export const storage = 'storage';
export const playground = 'playground';
export const spot = 'spot';
export const galleryConfig = 'galleryConfig';
export const navMoved = 'navMoved';
export const featureManager = 'featureManager';
